import * as ThankYouPageContant from './ThankYouPageContants';
import { ThankYouPageState } from './ThankYouPageTypes';

export default (state = ThankYouPageContant.DEFAULT_STATE, action: any): ThankYouPageState => {
  switch (action.type) {
    case ThankYouPageContant.ThankYouPageActionTypes.LOADED_THANK_YOU_PAGES:
      return { ...state, thankYouPagesMap: action.payload, reloadThankYouPagesMap: false };
    case ThankYouPageContant.ThankYouPageActionTypes.LOAD_FORM_VALUES:
      return { ...state, formValues: action.payload };
    default:
      return state;
  }
};
